import React, { useReducer, createContext, useEffect } from "react";
import cartReducer from "../reducers/cart-reducer";

export const CartContext = createContext();

const CartProvider = CartContext.Provider;

export function CartWrapper({ children }) {
  // Retrieve cart from localStorage or initialize as an empty array
  const storedCart =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("cart"))
      : null;

  const [cart, dispatchCart] = useReducer(cartReducer, storedCart || []);

  // Cache cart in localStorage when it changes
  useEffect(() => {
    if (cart) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }
  }, [cart]);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = React.useMemo(() => ({ cart, dispatchCart }), [cart]);

  return <CartProvider value={contextValue}>{children}</CartProvider>;
}
